import { render, staticRenderFns } from "./BaseFileList.vue?vue&type=template&id=31163ade"
import script from "./BaseFileList.vue?vue&type=script&lang=js"
export * from "./BaseFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports